import { Link } from 'foundations-components/transitional/components/Link';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { trackClickManageSeats } from '../utils/event-handlers';
import { useContext } from 'react';
import { TrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ManageSeatsLink = ({
  children
}) => {
  const trackUsage = useContext(TrackUsageContext);
  return /*#__PURE__*/_jsx(Link, {
    external: true,
    href: getUsersSeatsUrl(),
    onClick: () => trackUsage(trackClickManageSeats()),
    children: children
  });
};
ManageSeatsLink.displayName = 'ManageSeatsLink';